import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { I18NextPipe } from 'angular-i18next';
import { callbackDisplayConfigModel } from '../models';
import { callbackDisplayService } from 'src/app/services/services/callback-display.service';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import * as mainActions from 'src/app/state/app.actions'
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-callback-display-config',
    templateUrl: './callback-display-config.component.html',
    styleUrls: ['./callback-display-config.component.scss'],
    standalone: false
})
export class CallbackDisplayConfigComponent implements AfterViewInit,OnChanges {

  public configData: callbackDisplayConfigModel = {};


  private logoFile: File;
  public logo: any;
  private pictureFile: File;
  public picture: any;

  public isFullscreen: boolean = false;
  @Input() isNew: boolean = true;
  @Input() id: number = null;

  @Output() public closeEvent = new EventEmitter<any>();
  @Output() public refreshEvent = new EventEmitter<any>();
  @Output() public fullscreenEvent = new EventEmitter<boolean>();

  public formVal = { name: true, pageName: true, positionInQueue: true, lastUpdated: true, callbackNumber: true, cancel: true, cancelWarning: true, yes: true, no: true, cancelHeader: true, cancelBody: true, completedMessage: true, smsFrom: true,smsMessage:true };
  public formIsValid: boolean = true;

private initConfigData: callbackDisplayConfigModel = {
    pageName: 'Callback tracker',
    mainText: 'Main text',
    positionInQueue: 'Your current position in queue is',
    estimatedWaitTime: 'Estimated wait time',
    lastUpdated: 'Last updated',
    callbackNumber: 'The number we will call',
    cancel: 'Cancel',
    cancelWarning: 'Are you sure you want to Cancel?',
    yes: 'Yes',
    no: 'No',
    cancelHeader: 'Callback has been cancelled',
    cancelBody: 'If you wish to contact us later, please call xxxxxxxx or visit our web page',
    completedMessage: 'This callback has been done',
    expiredMessage: 'This link is no longer valid',
    smsMessage: 'Thank\'s for calling. To see your position in queue and cancel the callback, click: {{link}}',
    smsFrom: ''
}

  constructor(private i18nextPipe: I18NextPipe, private store: Store<State>, private service: callbackDisplayService,
    private activatedRoute: ActivatedRoute, private router: Router, private sanitizer: DomSanitizer) {
    for (const [key, value] of Object.entries(this.initConfigData)) {
      this.initConfigData[key] = i18nextPipe.transform('callbackDisplay:' + value, { link: '{{link}}' });
    }
  }

  ngAfterViewInit(): void {
    this.getConfig();
    this.checkIsValid(null, null);
  }

  ngOnChanges(changes: SimpleChanges) {
     this.getConfig();
     this.checkIsValid(null, null);
  }

  checkIsValid($event, propName) {
    if (propName) {
      this.formVal[propName] = $event;
    }
    this.formIsValid = Object.keys(this.formVal).map((key) => this.formVal[key]).every((val) => val);
  }
  back() {
    this.closeEvent.emit(true);
  }

  onFullscreen() {
    this.isFullscreen = !this.isFullscreen;
    this.fullscreenEvent.emit(this.isFullscreen);
  }

  resetConfig() {
    this.getConfig();
  }
  saveConfig() {
    this.service.saveCallbackDisplayConfig(this.configData, this.logoFile, this.pictureFile).subscribe(data => {
      if (data.body && data.ok) {
        this.getConfig();
        this.refreshEvent.emit(true);
        this.store.dispatch(
          mainActions.addMessage({
            message: new InfoMessage(
              this.i18nextPipe.transform('callbackDisplay:Configuration has been successfully saved.'), "")
          }));
        if (this.isNew) {
          this.back();
        }
      } else {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:Unable to save configuration!'),
              this.i18nextPipe.transform("callbackDisplay:Please try again later."))
          }));
      }
    });
  }

  logoInputChange(fileInputEvent: any) {
    if (fileInputEvent.target.files && fileInputEvent.target.files[0]) {
      //Limit file size to 2MB
      if (fileInputEvent.target.files[0].size > 2000000) {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:The file is too large.'), this.i18nextPipe.transform('callbackDisplay:Allowed maximum size is')+' 2Mb')
          }));
        return;
      }

      //Limit file type to png, jpg, jpeg
      const fileType = fileInputEvent.target.files[0].type;
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!allowedTypes.includes(fileType)) {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:Invalid file type.'), this.i18nextPipe.transform('callbackDisplay:Allowed types are')+' png, jpg, jpeg')
          }));
        return;
      }

      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.logo = e.target.result;
      }
      reader.readAsDataURL(fileInputEvent.target.files[0]);
      this.logoFile = fileInputEvent.target.files[0];
    }
  }

  pictureInputChange(fileInputEvent: any) {
    if (fileInputEvent.target.files && fileInputEvent.target.files[0]) {
      //Limit file size to 2MB
      if (fileInputEvent.target.files[0].size > 2000000) {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:The file is too large.'), this.i18nextPipe.transform('callbackDisplay:Allowed maximum size is')+' 2Mb')
          }));
        return;
      }

      //Limit file type to png, jpg, jpeg
      const fileType = fileInputEvent.target.files[0].type;
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!allowedTypes.includes(fileType)) {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:Invalid file type.'), this.i18nextPipe.transform('callbackDisplay:Allowed types are') + ' png, jpg, jpeg')
          }));
        return;
      }
      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.picture = e.target.result;
      }
      reader.readAsDataURL(fileInputEvent.target.files[0]);
      this.pictureFile = fileInputEvent.target.files[0];
    }
  }

  getConfig() {
    this.logo = null;
    this.picture = null;
    this.logoFile = null;
    this.pictureFile = null;
    if (this.isNew) {
      setTimeout(() => {
        this.configData = { ...this.initConfigData } ;
        this.checkIsValid(null, null);
      }, 0);
    }
    else if (isNaN(this.id)) {
      this.store.dispatch(
        mainActions.addMessage({
          message: new ErrorMessage(
            this.i18nextPipe.transform('callbackDisplay:Configuration was not found!'), "")
        }));
    }
    else {
      this.service.getCallbackDisplayConfig(this.id).subscribe(data => {
        if (data) {
          this.configData = data;
          this.checkIsValid(null, null);
        }
        else {
          this.store.dispatch(
            mainActions.addMessage({
              message: new ErrorMessage(
                this.i18nextPipe.transform('callbackDisplay:Configuration was not found!'), "")
            }));
        }
      });
      this.service.getCallbackDisplayConfigLogo(this.id).subscribe((blob: Blob) => {
        if (blob && blob.size > 0) {
          let objectURL = URL.createObjectURL(blob);
          this.logo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
      });
      this.service.getCallbackDisplayConfigPicture(this.id).subscribe((blob: Blob) => {
        if (blob && blob.size > 0) {
          let objectURL = URL.createObjectURL(blob);
          this.picture = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
      });

    }
  }
}
